import React, { useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { locations as cardLocations } from "./../data/mock-data";
import CarouselCard from "./CarouselCard";
import "./HomeCaroused.css";
import Slider from "react-slick";
import {
  IoChevronBackCircleSharp,
  IoArrowForwardCircle,
} from "react-icons/io5";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";

export function SampleNextArrow(props) {
  const { className, style, onClick } = props;

  return (
    <MdArrowForwardIos
      className={"next nextHomeCar"}
      style={{
        display: "block",
        boxShadow: "2px 2px 2px 2px black",
        borderRadius: "50%",
        width: 30,
        height: 30,
      }}
      onClick={onClick}
    />
  );
}

export function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <MdArrowBackIos
      className={"prev"}
      style={{
        display: "block",
        color: "white",
        borderRadius: "50%",
        width: 30,
        height: 30,
      }}
      onClick={onClick}
    />
  );
}

const HomeCaroused = () => {
  const [windowWidth, setWindowWidth] = useState(window.outerWidth);
  window.addEventListener("resize", function () {
    setWindowWidth(window.outerWidth);
  });

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow:
      windowWidth > 1000
        ? 4
        : windowWidth > 650
        ? 3
        : windowWidth > 500
        ? 2
        : 1,
    slidesToScroll: 1,
  };

  return (
    <div className="container-fluid">
      <p
        className="homeCatCatTitle"
        data-aos="fade-right"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
      >
        Best Rentals
      </p>
      {/* <hr className='homeCatHr' /> */}
      {/* <Slider {...settings}
                arrows={true}
                zIndex={2}
                className={'as ddd'}
                centerPadding={'40px'}
                prevArrow={<SamplePrevArrow />}
                nextArrow={<SampleNextArrow />}
                dots={false}> */}

      <div
        className={"as ddd col-md-12 d-flex flex-wrap justify-content-evenly"}
      >
        {cardLocations.map((v) => (
          <div className="CarInnerDiv">
            <CarouselCard location={v} carousel={true} />
          </div>
        ))}
      </div>

      {/* </Slider> */}
    </div>
  );
};

export default HomeCaroused;
